export const toYoutubeEmbed = (url = "") => {
  if (!url) return "";

  // Shorts
  const shorts = url.match(/youtube\.com\/shorts\/([^?&#/]+)/i);
  if (shorts?.[1]) return `https://www.youtube.com/embed/${shorts[1]}`;

  // youtu.be
  const short = url.match(/youtu\.be\/([^?&#/]+)/i);
  if (short?.[1]) return `https://www.youtube.com/embed/${short[1]}`;

  // watch?v=
  const watch = url.match(/[?&]v=([^?&#/]+)/i);
  if (watch?.[1]) return `https://www.youtube.com/embed/${watch[1]}`;

  // already embed
  if (/youtube\.com\/embed\//i.test(url)) return url;

  return url;
};